import { render, staticRenderFns } from "./UserMutedConfirm.vue?vue&type=template&id=2be6ddd4&"
import script from "./UserMutedConfirm.vue?vue&type=script&lang=ts&"
export * from "./UserMutedConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports